module.exports = __webpack_public_path__ + "static/img/facebook.72e9757.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = p8ve
// module chunks = 2